import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useEffect, useState } from "react";
import { Textarea, Text } from "@mantine/core";
const TextAreaWithCounter = ({ characterCounter, ...rest }) => {
    const [lengthCount, setLengthCount] = useState(0);
    const [characterCountStr, setCharacterCountStr] = useState("");
    useEffect(() => {
        var _a, _b;
        setLengthCount((_b = (_a = rest.value) === null || _a === void 0 ? void 0 : _a.toString().length) !== null && _b !== void 0 ? _b : 0);
    }, [rest.value]);
    useEffect(() => {
        setCharacterCountStr(`${lengthCount}/${rest.maxLength}`);
    }, [lengthCount]);
    return (_jsx(Textarea, { rightSection: characterCounter ? (_jsx(Text, { weight: 400, size: 12, children: characterCountStr })) : undefined, rightSectionWidth: (characterCountStr.length + 1) * 10, maxLength: rest.maxLength, styles: {
            input: {
                paddingRight: (characterCountStr.length + 1) * 10,
                overflow: "hidden",
                resize: "none",
            },
            rightSection: {
                alignItems: "flex-end",
                paddingBottom: 8,
            },
        }, ...rest }));
};
export default TextAreaWithCounter;
